import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = function runIdentityFunctionCheck(resultFunc, inputSelectorsResults, outputSelectorResult) {
  if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
    var isInputSameAsOutput = false;
    try {
      var emptyObject = {};
      if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
    } catch (_unused) {}
    if (isInputSameAsOutput) {
      var stack = void 0;
      try {
        throw new Error();
      } catch (e) {
        ;
        stack = e.stack;
      }
      console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
        stack: stack
      });
    }
  }
};

// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = function runInputStabilityCheck(inputSelectorResultsObject, options, inputSelectorArgs) {
  var memoize = options.memoize,
    memoizeOptions = options.memoizeOptions;
  var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults,
    inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
  var createAnEmptyObject = memoize.apply(void 0, [function () {
    return {};
  }].concat(_toConsumableArray(memoizeOptions)));
  var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
  if (!areInputSelectorResultsEqual) {
    var stack = void 0;
    try {
      throw new Error();
    } catch (e) {
      ;
      stack = e.stack;
    }
    console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
      arguments: inputSelectorArgs,
      firstInputs: inputSelectorResults,
      secondInputs: inputSelectorResultsCopy,
      stack: stack
    });
  }
};

// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = function setGlobalDevModeChecks(devModeChecks) {
  Object.assign(globalDevModeChecks, devModeChecks);
};

// src/utils.ts
var NOT_FOUND = /* @__PURE__ */Symbol("NOT_FOUND");
function assertIsFunction(func) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "expected a function, instead received ".concat(typeof func);
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "expected an object, instead received ".concat(typeof object);
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "expected all items to be functions, instead received the following types: ";
  if (!array.every(function (item) {
    return typeof item === "function";
  })) {
    var itemTypes = array.map(function (item) {
      return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item;
    }).join(", ");
    throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
  }
}
var ensureIsArray = function ensureIsArray(item) {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  var inputSelectorResults = [];
  var length = dependencies.length;
  for (var i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = function getDevModeChecksExecutionInfo(firstRun, devModeChecks) {
  var _globalDevModeChecks$ = _objectSpread(_objectSpread({}, globalDevModeChecks), devModeChecks),
    identityFunctionCheck = _globalDevModeChecks$.identityFunctionCheck,
    inputStabilityCheck = _globalDevModeChecks$.inputStabilityCheck;
  return {
    identityFunctionCheck: {
      shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
      run: runInputStabilityCheck
    }
  };
};

// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = /*#__PURE__*/function () {
  function Cell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tripleEq;
    _classCallCheck(this, Cell);
    _defineProperty(this, "revision", $REVISION);
    _defineProperty(this, "_value", void 0);
    _defineProperty(this, "_lastValue", void 0);
    _defineProperty(this, "_isEqual", tripleEq);
    this._value = this._lastValue = initialValue;
    this._isEqual = isEqual;
  }
  // Whenever a storage value is read, it'll add itself to the current tracker if
  // one exists, entangling its state with that cache.
  return _createClass(Cell, [{
    key: "value",
    get: function get() {
      var _CURRENT_TRACKER;
      (_CURRENT_TRACKER = CURRENT_TRACKER) === null || _CURRENT_TRACKER === void 0 || _CURRENT_TRACKER.add(this);
      return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    ,
    set: function set(newValue) {
      if (this.value === newValue) return;
      this._value = newValue;
      this.revision = ++$REVISION;
    }
  }]);
}();
function tripleEq(a, b) {
  return a === b;
}
var TrackingCache = /*#__PURE__*/function () {
  function TrackingCache(fn) {
    _classCallCheck(this, TrackingCache);
    _defineProperty(this, "_cachedValue", void 0);
    _defineProperty(this, "_cachedRevision", -1);
    _defineProperty(this, "_deps", []);
    _defineProperty(this, "hits", 0);
    _defineProperty(this, "fn", void 0);
    this.fn = fn;
  }
  return _createClass(TrackingCache, [{
    key: "clear",
    value: function clear() {
      this._cachedValue = void 0;
      this._cachedRevision = -1;
      this._deps = [];
      this.hits = 0;
    }
  }, {
    key: "value",
    get: function get() {
      var _CURRENT_TRACKER2;
      if (this.revision > this._cachedRevision) {
        var fn = this.fn;
        var currentTracker = /* @__PURE__ */new Set();
        var prevTracker = CURRENT_TRACKER;
        CURRENT_TRACKER = currentTracker;
        this._cachedValue = fn();
        CURRENT_TRACKER = prevTracker;
        this.hits++;
        this._deps = Array.from(currentTracker);
        this._cachedRevision = this.revision;
      }
      (_CURRENT_TRACKER2 = CURRENT_TRACKER) === null || _CURRENT_TRACKER2 === void 0 || _CURRENT_TRACKER2.add(this);
      return this._cachedValue;
    }
  }, {
    key: "revision",
    get: function get() {
      return Math.max.apply(Math, _toConsumableArray(this._deps.map(function (d) {
        return d.revision;
      })).concat([0]));
    }
  }]);
}();
function getValue(cell) {
  if (!(cell instanceof Cell)) {
    console.warn("Not a valid cell! ", cell);
  }
  return cell.value;
}
function setValue(storage, value) {
  if (!(storage instanceof Cell)) {
    throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
  }
  storage.value = storage._lastValue = value;
}
function createCell(initialValue) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tripleEq;
  return new Cell(initialValue, isEqual);
}
function createCache(fn) {
  assertIsFunction(fn, "the first parameter to `createCache` must be a function");
  return new TrackingCache(fn);
}

// src/autotrackMemoize/tracking.ts
var neverEq = function neverEq(a, b) {
  return false;
};
function createTag() {
  return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
  setValue(tag, value);
}
var consumeCollection = function consumeCollection(node) {
  var tag = node.collectionTag;
  if (tag === null) {
    tag = node.collectionTag = createTag();
  }
  getValue(tag);
};
var dirtyCollection = function dirtyCollection(node) {
  var tag = node.collectionTag;
  if (tag !== null) {
    dirtyTag(tag, null);
  }
};

// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = /*#__PURE__*/_createClass(function ObjectTreeNode(value) {
  _classCallCheck(this, ObjectTreeNode);
  _defineProperty(this, "proxy", new Proxy(this, objectProxyHandler));
  _defineProperty(this, "tag", createTag());
  _defineProperty(this, "tags", {});
  _defineProperty(this, "children", {});
  _defineProperty(this, "collectionTag", null);
  _defineProperty(this, "id", nextId++);
  this.value = value;
  this.value = value;
  this.tag.value = value;
});
var objectProxyHandler = {
  get: function get(node, key) {
    function calculateResult() {
      var value = node.value;
      var childValue = Reflect.get(value, key);
      if (typeof key === "symbol") {
        return childValue;
      }
      if (key in proto) {
        return childValue;
      }
      if (typeof childValue === "object" && childValue !== null) {
        var childNode = node.children[key];
        if (childNode === void 0) {
          childNode = node.children[key] = createNode(childValue);
        }
        if (childNode.tag) {
          getValue(childNode.tag);
        }
        return childNode.proxy;
      } else {
        var tag = node.tags[key];
        if (tag === void 0) {
          tag = node.tags[key] = createTag();
          tag.value = childValue;
        }
        getValue(tag);
        return childValue;
      }
    }
    var res = calculateResult();
    return res;
  },
  ownKeys: function ownKeys(node) {
    consumeCollection(node);
    return Reflect.ownKeys(node.value);
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(node, prop) {
    return Reflect.getOwnPropertyDescriptor(node.value, prop);
  },
  has: function has(node, prop) {
    return Reflect.has(node.value, prop);
  }
};
var ArrayTreeNode = /*#__PURE__*/_createClass(function ArrayTreeNode(value) {
  _classCallCheck(this, ArrayTreeNode);
  _defineProperty(this, "proxy", new Proxy([this], arrayProxyHandler));
  _defineProperty(this, "tag", createTag());
  _defineProperty(this, "tags", {});
  _defineProperty(this, "children", {});
  _defineProperty(this, "collectionTag", null);
  _defineProperty(this, "id", nextId++);
  this.value = value;
  this.value = value;
  this.tag.value = value;
});
var arrayProxyHandler = {
  get: function get(_ref, key) {
    var _ref2 = _slicedToArray(_ref, 1),
      node = _ref2[0];
    if (key === "length") {
      consumeCollection(node);
    }
    return objectProxyHandler.get(node, key);
  },
  ownKeys: function ownKeys(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      node = _ref4[0];
    return objectProxyHandler.ownKeys(node);
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(_ref5, prop) {
    var _ref6 = _slicedToArray(_ref5, 1),
      node = _ref6[0];
    return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
  },
  has: function has(_ref7, prop) {
    var _ref8 = _slicedToArray(_ref7, 1),
      node = _ref8[0];
    return objectProxyHandler.has(node, prop);
  }
};
function createNode(value) {
  if (Array.isArray(value)) {
    return new ArrayTreeNode(value);
  }
  return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
  var value = node.value,
    tags = node.tags,
    children = node.children;
  node.value = newValue;
  if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) {
    dirtyCollection(node);
  } else {
    if (value !== newValue) {
      var oldKeysSize = 0;
      var newKeysSize = 0;
      var anyKeysAdded = false;
      for (var _key in value) {
        oldKeysSize++;
      }
      for (var key in newValue) {
        newKeysSize++;
        if (!(key in value)) {
          anyKeysAdded = true;
          break;
        }
      }
      var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
      if (isDifferent) {
        dirtyCollection(node);
      }
    }
  }
  for (var _key2 in tags) {
    var childValue = value[_key2];
    var newChildValue = newValue[_key2];
    if (childValue !== newChildValue) {
      dirtyCollection(node);
      dirtyTag(tags[_key2], newChildValue);
    }
    if (typeof newChildValue === "object" && newChildValue !== null) {
      delete tags[_key2];
    }
  }
  for (var _key3 in children) {
    var childNode = children[_key3];
    var _newChildValue = newValue[_key3];
    var _childValue = childNode.value;
    if (_childValue === _newChildValue) {
      continue;
    } else if (typeof _newChildValue === "object" && _newChildValue !== null) {
      updateNode(childNode, _newChildValue);
    } else {
      deleteNode(childNode);
      delete children[_key3];
    }
  }
}
function deleteNode(node) {
  if (node.tag) {
    dirtyTag(node.tag, null);
  }
  dirtyCollection(node);
  for (var key in node.tags) {
    dirtyTag(node.tags[key], null);
  }
  for (var _key4 in node.children) {
    deleteNode(node.children[_key4]);
  }
}

// src/lruMemoize.ts
function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }
      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = void 0;
    }
  };
}
function createLruCache(maxSize, equals) {
  var entries = [];
  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    });
    if (cacheIndex > -1) {
      var entry = entries[cacheIndex];
      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }
      return entry.value;
    }
    return NOT_FOUND;
  }
  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      entries.unshift({
        key: key,
        value: value
      });
      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }
  function getEntries() {
    return entries;
  }
  function clear() {
    entries = [];
  }
  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}
var referenceEqualityCheck = function referenceEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    }
    var length = prev.length;
    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }
    return true;
  };
}
function lruMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
    equalityCheck = _providedOptions$equa === void 0 ? referenceEqualityCheck : _providedOptions$equa,
    _providedOptions$maxS = providedOptions.maxSize,
    maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
    resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var resultsCount = 0;
  var cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
  function memoized() {
    var value = cache.get(arguments);
    if (value === NOT_FOUND) {
      value = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });
        if (matchingEntry) {
          value = matchingEntry.value;
          resultsCount !== 0 && resultsCount--;
        }
      }
      cache.put(arguments, value);
    }
    return value;
  }
  memoized.clearCache = function () {
    cache.clear();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = function () {
    return resultsCount;
  };
  memoized.resetResultsCount = function () {
    resultsCount = 0;
  };
  return memoized;
}

// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
  var node = createNode([]);
  var lastArgs = null;
  var shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
  var cache = createCache(function () {
    var res = func.apply(null, node.proxy);
    return res;
  });
  function memoized() {
    if (!shallowEqual(lastArgs, arguments)) {
      updateNode(node, arguments);
      lastArgs = arguments;
    }
    return cache.value;
  }
  memoized.clearCache = function () {
    return cache.clear();
  };
  return memoized;
}

// src/weakMapMemoize.ts
var StrongRef = /*#__PURE__*/function () {
  function StrongRef(value) {
    _classCallCheck(this, StrongRef);
    this.value = value;
  }
  return _createClass(StrongRef, [{
    key: "deref",
    value: function deref() {
      return this.value;
    }
  }]);
}();
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fnNode = createCacheNode();
  var resultEqualityCheck = options.resultEqualityCheck;
  var lastResult;
  var resultsCount = 0;
  function memoized() {
    var cacheNode = fnNode;
    var length = arguments.length;
    for (var i = 0, l = length; i < l; i++) {
      var arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        var objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */new WeakMap();
        }
        var objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        var primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */new Map();
        }
        var primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    var terminatedNode = cacheNode;
    var result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        var _lastResult$deref, _lastResult, _lastResult$deref2;
        var lastResultValue = (_lastResult$deref = (_lastResult = lastResult) === null || _lastResult === void 0 || (_lastResult$deref2 = _lastResult.deref) === null || _lastResult$deref2 === void 0 ? void 0 : _lastResult$deref2.call(_lastResult)) !== null && _lastResult$deref !== void 0 ? _lastResult$deref : lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = function () {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = function () {
    return resultsCount;
  };
  memoized.resetResultsCount = function () {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key5 = 1; _key5 < _len; _key5++) {
    memoizeOptionsFromArgs[_key5 - 1] = arguments[_key5];
  }
  var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  var createSelector2 = function createSelector2() {
    for (var _len2 = arguments.length, createSelectorArgs = new Array(_len2), _key6 = 0; _key6 < _len2; _key6++) {
      createSelectorArgs[_key6] = arguments[_key6];
    }
    var _recomputations = 0;
    var _dependencyRecomputations = 0;
    var _lastResult2;
    var directlyPassedOptions = {};
    var resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc, "]"));
    var combinedOptions = _objectSpread(_objectSpread({}, createSelectorCreatorOptions), directlyPassedOptions);
    var memoize = combinedOptions.memoize,
      _combinedOptions$memo = combinedOptions.memoizeOptions,
      memoizeOptions = _combinedOptions$memo === void 0 ? [] : _combinedOptions$memo,
      _combinedOptions$args = combinedOptions.argsMemoize,
      argsMemoize = _combinedOptions$args === void 0 ? weakMapMemoize : _combinedOptions$args,
      _combinedOptions$args2 = combinedOptions.argsMemoizeOptions,
      argsMemoizeOptions = _combinedOptions$args2 === void 0 ? [] : _combinedOptions$args2,
      _combinedOptions$devM = combinedOptions.devModeChecks,
      devModeChecks = _combinedOptions$devM === void 0 ? {} : _combinedOptions$devM;
    var finalMemoizeOptions = ensureIsArray(memoizeOptions);
    var finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    var dependencies = getDependencies(createSelectorArgs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++;
      return resultFunc.apply(null, arguments);
    }].concat(_toConsumableArray(finalMemoizeOptions)));
    var firstRun = true;
    var selector = argsMemoize.apply(void 0, [function dependenciesChecker() {
      _dependencyRecomputations++;
      var inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
      _lastResult2 = memoizedResultFunc.apply(null, inputSelectorResults);
      if (process.env.NODE_ENV !== "production") {
        var _getDevModeChecksExec = getDevModeChecksExecutionInfo(firstRun, devModeChecks),
          identityFunctionCheck = _getDevModeChecksExec.identityFunctionCheck,
          inputStabilityCheck = _getDevModeChecksExec.inputStabilityCheck;
        if (identityFunctionCheck.shouldRun) {
          identityFunctionCheck.run(resultFunc, inputSelectorResults, _lastResult2);
        }
        if (inputStabilityCheck.shouldRun) {
          var inputSelectorResultsCopy = collectInputSelectorResults(dependencies, arguments);
          inputStabilityCheck.run({
            inputSelectorResults: inputSelectorResults,
            inputSelectorResultsCopy: inputSelectorResultsCopy
          }, {
            memoize: memoize,
            memoizeOptions: finalMemoizeOptions
          }, arguments);
        }
        if (firstRun) firstRun = false;
      }
      return _lastResult2;
    }].concat(_toConsumableArray(finalArgsMemoizeOptions)));
    return Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      dependencyRecomputations: function dependencyRecomputations() {
        return _dependencyRecomputations;
      },
      resetDependencyRecomputations: function resetDependencyRecomputations() {
        _dependencyRecomputations = 0;
      },
      lastResult: function lastResult() {
        return _lastResult2;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        _recomputations = 0;
      },
      memoize: memoize,
      argsMemoize: argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: function withTypes() {
      return createSelector2;
    }
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(function (inputSelectorsObject) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
  assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject));
  var inputSelectorKeys = Object.keys(inputSelectorsObject);
  var dependencies = inputSelectorKeys.map(function (key) {
    return inputSelectorsObject[key];
  });
  var structuredSelector = selectorCreator(dependencies, function () {
    for (var _len3 = arguments.length, inputSelectorResults = new Array(_len3), _key7 = 0; _key7 < _len3; _key7++) {
      inputSelectorResults[_key7] = arguments[_key7];
    }
    return inputSelectorResults.reduce(function (composition, value, index) {
      composition[inputSelectorKeys[index]] = value;
      return composition;
    }, {});
  });
  return structuredSelector;
}, {
  withTypes: function withTypes() {
    return createStructuredSelector;
  }
});
export { createSelector, createSelectorCreator, createStructuredSelector, lruMemoize, referenceEqualityCheck, setGlobalDevModeChecks, autotrackMemoize as unstable_autotrackMemoize, weakMapMemoize };